import { Checkbox, Field, Label } from '@headlessui/react'
import { Check } from 'lucide-react'

type BaseCheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  boxClassName?: string
  iconClassName?: string
  label?: React.ReactNode
  error?: string
  variant?: 'default' | 'secondary'
  fieldClassName?: string
  leftIcon?: React.ReactNode
  size?: 'sm' | 'md'
}

export const BaseCheckbox = ({
  label,
  checked,
  onChange,
  boxClassName,
  iconClassName,
  error,
  variant,
  fieldClassName,
  leftIcon,
  size = 'md',
}: BaseCheckboxProps) => {
  const variantLabelClasses =
    variant === 'default'
      ? 'text-text-main dark:text-text-secondary'
      : 'text-text-main dark:text-white'

  const sizeBoxClasses = size === 'sm' ? 'size-4 p-0.5 rounded-sm' : 'size-6 p-1 rounded-md'
  const sizeIconClasses = size === 'sm' ? 'size-3' : 'size-4'

  return (
    <Field className={`w-full flex items-center gap-2 relative ${fieldClassName || ''}`}>
      <Checkbox
        checked={checked}
        onChange={onChange}
        className={`group block border border-card-border bg-white dark:bg-transparent ring-inset data-[checked]:bg-primary data-[checked]:dark:bg-primary-dark data-[checked]:border-none
        ${sizeBoxClasses} ${boxClassName}`}
      >
        <Check
          className={`text-white dark:text-dark-bg invisible fill-black group-data-[checked]:visible
          ${sizeIconClasses} ${iconClassName}`}
        />
      </Checkbox>
      {leftIcon && (
        <span className="top-1/2 left-0 absolute -translate-y-1/2 transform w-5 h-5 flex items-center justify-center">{leftIcon}</span>
      )}
      {label && (
        <Label className={`${variantLabelClasses} ${leftIcon ? 'pl-7' : ''}`}>{label}</Label>
      )}
      {error && <span className="right-0 -bottom-4 absolute text-error text-xs">{error}</span>}
    </Field>
  )
}
